export const INSTAGRAM_EMBED_SCRIPT_SRC = "https://www.instagram.com/embed.js";

let loaderPromise = null;

const getInstagramApi = () =>
  typeof window !== "undefined" ? window.instgrm?.Embeds : undefined;

export function loadInstagramEmbedScript() {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return Promise.reject(new Error("Instagram embed requires a browser environment."));
  }

  if (getInstagramApi()?.process) {
    return Promise.resolve(getInstagramApi());
  }

  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[src="${INSTAGRAM_EMBED_SCRIPT_SRC}"]`
    );

    const handleLoad = () => {
      const api = getInstagramApi();
      if (api?.process) {
        resolve(api);
        return;
      }
      loaderPromise = null;
      reject(new Error("Instagram embed API was not initialized."));
    };

    const handleError = () => {
      loaderPromise = null;
      reject(new Error("Instagram embed script failed to load."));
    };

    if (existingScript) {
      existingScript.addEventListener("load", handleLoad, { once: true });
      existingScript.addEventListener("error", handleError, { once: true });
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src = INSTAGRAM_EMBED_SCRIPT_SRC;
    script.dataset.telefonkaInstagramEmbed = "true";
    script.addEventListener("load", handleLoad, { once: true });
    script.addEventListener("error", handleError, { once: true });
    document.body.appendChild(script);
  });

  return loaderPromise;
}
